<template>
  <div class="card shadow mt-2 mb-3 border-0">
    <div class="card-body">
      <div class="title">
        <div class="wrap">
          <h5>Управление пользователями</h5>
          <div class="sub-title">Добавленные пользователи могут только просматривать данные, но не изменять</div>
        </div>
        <button class="btn btn-primary ms-auto btn-sm" @click="add_user={}"><i class="bi bi-plus-lg"></i> Добавить
          пользователя
        </button>
      </div>
      <div v-if="add_user" class="div add-user">
        <form action="" @submit.prevent="addUserPerm">

          <h5>Введите email адрес пользователя</h5>
          <input required v-model="add_user.email" type="email" class="form-control" placeholder="Email адрес">
          <div class="help-text">Пользователю будет отправлено приглашение на указанную почту для активации учётной
            записи и создания пароля. Если аккаунт уже существует, доступ предоставится автоматически.
          </div>
          <div class="buttons">
            <button class="btn btn-primary">Отправить</button>
            <button class="btn btn-secondary" @click="add_user=null">Отмена</button>
          </div>
        </form>
      </div>
      <ul class="users">
        <li class="border border-info rounded bg-info bg-opacity-10 user-info owner">
          <div class="ico">
            {{ $getShortName(user.fullname) }}
          </div>
          <div class="info">
            <strong class="email">{{ user.email }}</strong>
            <div class="sub-info">Вы Владелец организации</div>
          </div>
          <div class="badge bg-primary ms-auto">Администратор</div>

        </li>
        <li class="rounded bg-opacity-10 user-info" v-for="user_perm in users">
          <div class="ico">
            {{ $getShortName(user_perm.user.fullname) }}
          </div>
          <div class="info">
            <strong class="email">{{ user_perm.user.email }}</strong>
            <div class="sub-info">Добавлен: <span v-if="user_perm.date_accepted ">{{ $moment(user_perm.date_accepted).format("DD.MM.YYYY HH:mm") }}</span></div>
          </div>
          <div class="buttons ms-auto">
            <div class="badge bg-secondary" v-if="user_perm.accept">Только просмотр</div>
            <div class="badge bg-warning" v-else>Ожидает подтверждения</div>
            <a href="" @click.prevent="deletePerm(user_perm.id)" class="text-danger">
              <i class="bi bi-trash3"></i>
            </a>
          </div>

        </li>
        <li class="rounded border-warning bg-opacity-10 user-info bg-warning align-items-start"
            style="font-size: 14px">
          <i class="bi bi-info-circle text-warning"></i>
          <div class="info">
            <p><strong>Права пользователей с доступом "Только просмотр": </strong></p>
            <ul>
              <li>Просмотр всех дашбордов и статистики</li>
              <li>Просмотр отзывов и аналитики</li>
              <li>Экспорт отчётов</li>
              <li><strong>Не могут:</strong> изменять настройки, добавлять ссылки, запускать парсинг, управлять
                пользователями
              </li>
            </ul>
          </div>

        </li>
      </ul>

    </div>
  </div>

</template>

<script>


import {ProjectApi} from "@/api/projects";

export default {
  name: 'UsersPermission',
  components: {},
  props: {},
  data() {
    return {
      add_user: null,
      users: []
    }

  },
  watch: {},
  mounted: function () {
      ProjectApi.get_user_perm().then(response=>this.users=response).catch(()=>{

    })
  },
  computed: {
    user: {
      get() {
        return this.$store.getters.user
      },
      set(value) {
        this.$store.dispatch('update_user', value)
      }
    },
  },

  methods: {
    deletePerm(perm_id){
      ProjectApi.delete_user_perm(perm_id).then(()=>{
        let perm_index = this.users.findIndex(x=>x.id===perm_id)
        this.users.splice(perm_index, 1)
        this.$notify({
          type: 'success',
          text: "Права отозваны"
        });
      })
    },
    addUserPerm(){
      ProjectApi.add_user_perm({project_id: this.$store.getters.currentProjectId, email: this.add_user.email}
      ).then(response=>{
        this.add_user = null;
        this.users = response;
         this.$notify({
          type: 'success',
          text: "Пользователь добавлен"
        });
      }).catch((err)=>{
        this.$notify({
          type: 'error',
          text: err.response.data.error || err.response.data.detail
        });
      })
    },
  }
}

</script>
<style scoped lang="scss">
.users {
  list-style: none;
  margin: 0;
  display: flex;
  gap: 15px;
  padding: 0;
  flex-direction: column;

  .user-info {
    position: relative;
    display: flex;
    gap: 10px;
    padding: 10px;
    width: 100%;
    align-items: center;
    border: 1px solid var(--soft-grey);

    .buttons {
      display: flex;
      gap: 15px;
      align-items: center;
    }

    &.owner {
      .ico {
        background-color: var(--primary);
        color: var(--white);
      }
    }

    .sub-info {
      font-size: 12px;
      color: var(--grey);
    }

    .btn {
      height: 30px;
      border-radius: 30px;
    }

    .ico {
      border-radius: 100px;
      background-color: var(--grey);
      font-weight: bold;
      font-size: 16px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--dark-grey);
      height: 40px;
    }
  }
}

.add-user {
  position: absolute;
  top: 0;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(3px);
  width: 100%;
  height: 100%;
  z-index: 10;

  form {
    background: var(--white);
    padding: 20px;
    border-radius: 10px;
    width: max-content;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-shadow: var(--shadow);

    .buttons {
      display: flex;
      gap: 20px;

    }
  }

}

</style>

